import React, { useEffect, useState, useMemo, useRef } from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import copyThumb from '../assets/images/copy-new.svg'
import checkedCopy from '../assets/images/checkedCopy.svg'

const useStyles = makeStyles({
  main: {
    height: '415px',
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    scrollbarWidth: 'thin',
    scrollbarColor: '#D1D1D1 transparent',
    borderRadius: '3px',
    paddingLeft: 16,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  mainMobile: {
    height: '250px',
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    scrollbarWidth: 'thin',
    scrollbarColor: '#D1D1D1 transparent',
    borderRadius: '3px',
    paddingLeft: 16,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  itemDetail: {
    borderBottom: '1px solid #DFE4EB',
    width: '100%',
    padding: '12px 0px',
    margin: 0,
  },
  item: {
    alignItems: 'flex-start',
    lineHeight: '22px',
    padding: 0,
  },
  date: {
    display: 'flex',
    fontSize: 10,
    color: '#8C8C8C',
    cursor: 'pointer',
    '& div:first-child': {
      width: 80,
      whiteSpace: 'nowrap',
    },
    '&:hover': {
      '& div:first-child': {
        color: '#474747',
      },
      '& div:nth-child(2)': {
        color: '#2160BA',
      },
    },
  },
  title: {
    color: '#1B3963',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left',
    width: '100%',
    paddingRight: 10,
    lineHeight: '18px',
    position: 'relative',
  },
  titleRiskStory: {
    fontWeight: 400,
    fontSize: 13.5,
    width: '100%',
    lineHeight: '20px',
    position: 'relative',
    marginTop: 5,
  },
  titleRiskStoryMobile: {
    fontWeight: 400,
    fontSize: 13,
    width: '100%',
    lineHeight: '20px',
    position: 'relative',
  },
  riskStoryDate: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 13.5,
    lineHeight: '20px',
    letterSpacing: 0,
    color: '#000000',
    // marginBottom: 5,
  },
  content: {
    paddingTop: 10,
    fontSize: 12,
    color: '#181818',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
  noDataText: {
    fontSize: 15,
    color: '#1B3963',
    fontWeight: 450,
    textAlign: 'left',
    width: '100%',
    paddingTop: 10,
    position: 'relative',
    top: 10,
  },
  copyIcon: {
    cursor: 'pointer',
    marginLeft: 8,
    width: 16,
    height: 16,
    verticalAlign: 'middle',
  },
  copiedText: {
    marginLeft: 8,
    fontSize: 12,
    color: 'green',
    display: 'inline-block',
  },
  eventFeed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E8EBEF',
  },
  subheading: {
    marginBottom: 10,
    fontSize: 14,
    color: '#474747',
    fontWeight: 600,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E8EBEF',
    // paddingBottom: 5,
    marginBottom: 8,
  },
  headerTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#181818',
  },
  headerTitleMobile: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#181818',
    display: 'block',
  },
  headerSubTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#757575',
    marginLeft: 6,
  },
  headerSubTitleMobile: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 10,
    lineHeight: '14px',
    letterSpacing: 0,
    color: '#757575',
    marginLeft: 0,
    marginTop: 2,
    display: 'block',
  },
  copyButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 8px',
    borderRadius: 4,
    border: '1px solid #E6EAF0',
    background: '#FFFFFF',
    cursor: 'pointer',
    marginBottom: 5,
  },
  copyButtonText: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#1B3963',
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    scrollbarWidth: 'thin',
    scrollbarColor: '#D1D1D1 transparent',
    paddingRight: 8,
    minHeight: 0,
    position: 'relative',
    '&[data-scrollable="true"]': {
      backgroundImage:
        'linear-gradient(to left, rgba(209, 209, 209, 0.9) 0, rgba(209, 209, 209, 0.9) 3px, transparent 3px)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right top',
      backgroundSize: '3px 100%',
    },

    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
  },
  splitGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gridTemplateRows: 'minmax(0, 1fr)',
    gap: '24px 10px',
    height: '100%',
    minHeight: 0,
    flex: 1,
  },
  splitItem: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    height: '100%',
  },
  splitItemBody: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    scrollbarWidth: 'thin',
    scrollbarColor: '#D1D1D1 transparent',
    minHeight: 0,
    paddingRight: 8,
    position: 'relative',
    '&[data-scrollable="true"]': {
      backgroundImage:
        'linear-gradient(to left, rgba(209, 209, 209, 0.9) 0, rgba(209, 209, 209, 0.9) 3px, transparent 3px)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right top',
      backgroundSize: '3px 100%',
    },
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
  },
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 24,
  },
  contentItem: {
    minWidth: 0,
  },
})

interface NewsFeedProps {
  latestRiskStoryData: any
  title?: string
  subTitle?: string
  showCopyButton?: boolean
  showContentBorder?: boolean
  splitColumns?: boolean
  fullHeight?: boolean
  textFontSize?: number
  dateFontSize?: number
}

const NewsFeed = ({
  latestRiskStoryData,
  title = 'Risk Story',
  subTitle,
  showCopyButton = true,
  showContentBorder = true,
  splitColumns = false,
  fullHeight = false,
  textFontSize,
  dateFontSize,
}: NewsFeedProps) => {
  const classes = useStyles()
  const [currentItemIndex, setCurrentItemIndex] = useState(0)
  const [wordIndexes, setWordIndexes] = useState<number[]>([])
  const [copied, setCopied] = useState(false)
  const isParallelRender = splitColumns && !isMobile
  const rootRef = useRef<HTMLElement | null>(null)
  const isMac = useMemo(() => {
    if (typeof navigator === 'undefined') return false
    return /Mac/.test(navigator.platform)
  }, [])

  const moveToLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  const handleCopy = () => {
    const items = Array.isArray(latestRiskStoryData)
      ? latestRiskStoryData
      : latestRiskStoryData
      ? [latestRiskStoryData]
      : []
    const textToCopy = items[0]?.signal_overview
    if (!textToCopy) return

    if (
      navigator &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === 'function' &&
      window.isSecureContext
    ) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 1500)
        })
        .catch(err => {
          console.error('Copy failed using Clipboard API:', err)
        })
    } else {
      const textArea = document.createElement('textarea')
      textArea.value = textToCopy
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      } catch (err) {
        console.error('Fallback: Copy failed using execCommand:', err)
      }

      document.body.removeChild(textArea)
    }
  }

  const riskStoryItems = useMemo(() => {
    if (!latestRiskStoryData) return []
    const items = Array.isArray(latestRiskStoryData)
      ? latestRiskStoryData
      : [latestRiskStoryData]
    const getDateValue = (item: any) => {
      if (!item?.date) return Number.POSITIVE_INFINITY
      const time = new Date(item.date).getTime()
      return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time
    }
    return [...items].sort((a, b) => getDateValue(a) - getDateValue(b))
  }, [latestRiskStoryData])

  const riskStoryMaxLength = useMemo(() => {
    if (!riskStoryItems.length) return 0
    return riskStoryItems.reduce((max, item) => {
      const len = (item?.signal_overview ?? '').length
      return len > max ? len : max
    }, 0)
  }, [riskStoryItems])
  const autoRiskStoryTextStyle = useMemo(() => {
    if (isMobile || textFontSize) return undefined
    if (riskStoryMaxLength > 810) {
      return { fontSize: 12, lineHeight: '18px' }
    }
    if (riskStoryMaxLength >= 665) {
      return { fontSize: 13.5 }
    }
    return { fontSize: 15 }
  }, [isMobile, riskStoryMaxLength, textFontSize])

  const wordsList = useMemo(() => {
    return riskStoryItems.map(item =>
      item?.signal_overview ? item.signal_overview.split(' ') : [],
    )
  }, [riskStoryItems])
  const isTypingComplete = useMemo(() => {
    if (wordsList.length === 0) return true
    return wordsList.every(
      (words, index) => (wordIndexes[index] ?? 0) >= words.length,
    )
  }, [wordIndexes, wordsList])

  useEffect(() => {
    if (wordsList.length === 0) {
      setWordIndexes([])
      setCurrentItemIndex(0)
      return
    }
    setWordIndexes(wordsList.map(() => 0))
    setCurrentItemIndex(0)
  }, [wordsList.length])

  useEffect(() => {
    if (!isParallelRender || wordsList.length === 0) {
      return () => {}
    }
    let intervalId: number | null = window.setInterval(() => {
      let done = true
      setWordIndexes(prev => {
        const next =
          prev.length === wordsList.length ? [...prev] : wordsList.map(() => 0)
        for (let i = 0; i < wordsList.length; i += 1) {
          const len = wordsList[i]?.length ?? 0
          if ((next[i] ?? 0) < len) {
            next[i] = (next[i] ?? 0) + 1
            done = false
          }
        }
        return next
      })
      if (done && intervalId !== null) {
        window.clearInterval(intervalId)
        intervalId = null
      }
    }, 30)

    return () => {
      if (intervalId !== null) {
        window.clearInterval(intervalId)
      }
    }
  }, [isParallelRender, wordsList])

  useEffect(() => {
    if (isParallelRender || wordsList.length === 0) {
      return () => {}
    }
    const currentWords = wordsList[currentItemIndex] ?? []
    const currentWordIndex = wordIndexes[currentItemIndex] ?? 0

    if (currentWordIndex >= currentWords.length) {
      if (currentItemIndex < wordsList.length - 1) {
        setCurrentItemIndex(prev => prev + 1)
      }
      return () => {}
    }

    const intervalId = window.setInterval(() => {
      setWordIndexes(prev => {
        const next = [...prev]
        next[currentItemIndex] = (next[currentItemIndex] ?? 0) + 1
        return next
      })
    }, 30)

    return () => window.clearInterval(intervalId)
  }, [currentItemIndex, isParallelRender, wordIndexes, wordsList])

  useEffect(() => {
    if (isMobile || !isMac) return () => {}
    const root = rootRef.current
    if (!root) return () => {}
    const elements = Array.from(
      root.querySelectorAll('[data-scroll-indicator="true"]'),
    ) as HTMLElement[]
    if (!elements.length) return () => {}

    const update = () => {
      elements.forEach(element => {
        const hasOverflow = element.scrollHeight > element.clientHeight + 1
        if (hasOverflow) {
          element.setAttribute('data-scrollable', 'true')
        } else {
          element.removeAttribute('data-scrollable')
        }
      })
    }

    update()
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('resize', update)
    }
  }, [isMac, isMobile, isTypingComplete, riskStoryItems.length, splitColumns])

  const contentHeight = showContentBorder ? '415px' : '100%'

  return (
    <section
      ref={rootRef}
      style={
        fullHeight
          ? {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }
          : undefined
      }
    >
      <div className={classes.header}>
        <div>
          <span
            className={
              isMobile ? classes.headerTitleMobile : classes.headerTitle
            }
          >
            {title}
          </span>
          {subTitle && (
            <span
              className={
                isMobile ? classes.headerSubTitleMobile : classes.headerSubTitle
              }
            >
              ({subTitle})
            </span>
          )}
        </div>
        {showCopyButton && (
          <div
            className={classes.copyButton}
            data-pdf-hide
            onClick={e => {
              if (!isTypingComplete) return
              e.stopPropagation()
              handleCopy()
            }}
            style={{
              visibility: isTypingComplete ? 'visible' : 'hidden',
              pointerEvents: isTypingComplete ? 'auto' : 'none',
            }}
          >
            <img
              src={copied ? checkedCopy : copyThumb}
              alt="Copy"
              style={{ width: 16, height: 16 }}
            />
            <span className={classes.copyButtonText}>Copy</span>
          </div>
        )}
      </div>
      <div
        data-pdf-expand="height"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: contentHeight,
          overflow: 'hidden',
          border: showContentBorder ? '1px solid #DFE4EB' : 'none',
          borderRadius: showContentBorder ? 4 : 0,
          flex: fullHeight ? 1 : undefined,
          minHeight: fullHeight ? 0 : undefined,
        }}
      >
        {riskStoryItems.length > 0 ? (
          splitColumns ? (
            <div
              style={{ height: '100%', minHeight: 0, display: 'flex' }}
              data-pdf-expand="height"
            >
              <div className={classes.splitGrid} data-pdf-expand="height">
                {riskStoryItems.map((item, index) => {
                  const words = wordsList[index] ?? []
                  const wordIndex = wordIndexes[index] ?? 0
                  const displayWords = words.slice(0, wordIndex).join(' ')
                  const showCursor = isParallelRender
                    ? wordIndex < words.length
                    : index === currentItemIndex && wordIndex < words.length
                  const isVisible = isParallelRender
                    ? true
                    : index <= currentItemIndex
                  const inlineTextStyle =
                    !isMobile && textFontSize
                      ? { fontSize: textFontSize }
                      : autoRiskStoryTextStyle
                  const inlineDateStyle =
                    !isMobile && dateFontSize
                      ? { fontSize: dateFontSize }
                      : undefined
                  if (!isVisible) return null
                  return (
                    <div key={item?.id ?? index} className={classes.splitItem}>
                      {isMobile && (
                        <div className={classes.riskStoryDate}>
                          {item?.date
                            ? moment(item.date).format('MMM DD, YYYY')
                            : ''}
                        </div>
                      )}
                      <div
                        className={classes.splitItemBody}
                        data-pdf-expand="scroll"
                        data-scroll-indicator="true"
                      >
                        <Typography
                          className={
                            isMobile
                              ? classes.titleRiskStoryMobile
                              : classes.titleRiskStory
                          }
                          style={inlineTextStyle}
                          data-pdf-risk-title
                          onClick={() => moveToLink(item?.url)}
                        >
                          {!isMobile && item?.date && (
                            <span
                              className={classes.riskStoryDate}
                              data-pdf-inline-date
                              style={inlineDateStyle}
                            >
                              {moment(item.date).format('MMM DD, YYYY')}:{' '}
                            </span>
                          )}
                          <span
                            data-pdf-full-text={item?.signal_overview ?? ''}
                          >
                            {displayWords}
                          </span>
                          <span
                            className="cursor"
                            style={{
                              opacity: showCursor ? 1 : 0,
                            }}
                          >
                            &#10074;
                          </span>
                        </Typography>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          ) : (
            <div
              className={classes.scrollContainer}
              data-pdf-expand="scroll"
              data-scroll-indicator="true"
            >
              <div>
                {riskStoryItems.map((item, index) => {
                  const words = wordsList[index] ?? []
                  const wordIndex = wordIndexes[index] ?? 0
                  const displayWords = words.slice(0, wordIndex).join(' ')
                  const showCursor = isParallelRender
                    ? wordIndex < words.length
                    : index === currentItemIndex && wordIndex < words.length
                  const isVisible = isParallelRender
                    ? true
                    : index <= currentItemIndex
                  const inlineTextStyle =
                    !isMobile && textFontSize
                      ? { fontSize: textFontSize }
                      : autoRiskStoryTextStyle
                  const inlineDateStyle =
                    !isMobile && dateFontSize
                      ? { fontSize: dateFontSize }
                      : undefined
                  if (!isVisible) return null
                  return (
                    <div key={item?.id ?? index} style={{ marginBottom: 18 }}>
                      {isMobile && (
                        <div className={classes.riskStoryDate}>
                          {item?.date
                            ? moment(item.date).format('MMM DD, YYYY')
                            : ''}
                        </div>
                      )}
                      <Typography
                        className={
                          isMobile
                            ? classes.titleRiskStoryMobile
                            : classes.titleRiskStory
                        }
                        style={inlineTextStyle}
                        data-pdf-risk-title
                        onClick={() => moveToLink(item?.url)}
                      >
                        {!isMobile && item?.date && (
                          <span
                            className={classes.riskStoryDate}
                            data-pdf-inline-date
                            style={inlineDateStyle}
                          >
                            {moment(item.date).format('MMM DD, YYYY')}:{' '}
                          </span>
                        )}
                        <span data-pdf-full-text={item?.signal_overview ?? ''}>
                          {displayWords}
                        </span>
                        <span
                          className="cursor"
                          style={{
                            opacity: showCursor ? 1 : 0,
                          }}
                        >
                          &#10074;
                        </span>
                      </Typography>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        ) : null}
      </div>
    </section>
  )
}

export default NewsFeed
